export enum TransactionOptionsModalCommands {
  TransactionBasedReturn = 'Transaction Based Return',
  ReturnAll = 'Return All',
  Reprint = 'Reprint',
  GiftReceipt = 'Gift Receipt',
}
